"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledIcon = exports.StyledCloseIcon = exports.StyledAlert = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

var StyledAlert = _styledComponents["default"].div.withConfig({
  displayName: "Alertstyles__StyledAlert",
  componentId: "sc-h4zmd3-0"
})(["", " border-width:1px;white-space:pre-line;"], (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n    flex lh-title\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), function (_ref) {
  var alert = _ref.theme.alert,
      type = _ref.type;
  return alert.types[type];
}, function (_ref2) {
  var alert = _ref2.theme.alert;
  return alert === null || alert === void 0 ? void 0 : alert.base;
}, function (_ref3) {
  var alert = _ref3.theme.alert;
  return alert === null || alert === void 0 ? void 0 : alert.spacing;
}, function (_ref4) {
  var alert = _ref4.theme.alert;
  return alert === null || alert === void 0 ? void 0 : alert.typography;
}));

exports.StyledAlert = StyledAlert;

var StyledIcon = _styledComponents["default"].div.withConfig({
  displayName: "Alertstyles__StyledIcon",
  componentId: "sc-h4zmd3-1"
})(["", " & i{", "}"], (0, _ty["default"])(_templateObject2 || (_templateObject2 = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n    pr2 lh-solid f4 flex items-center\n  "])), function (_ref5) {
  var _alert$icons$type;

  var alert = _ref5.theme.alert,
      type = _ref5.type;
  return (_alert$icons$type = alert.icons[type]) === null || _alert$icons$type === void 0 ? void 0 : _alert$icons$type.color;
}), (0, _ty["default"])(_templateObject3 || (_templateObject3 = (0, _taggedTemplateLiteral2["default"])(["flex"]))));

exports.StyledIcon = StyledIcon;

var StyledCloseIcon = _styledComponents["default"].div.withConfig({
  displayName: "Alertstyles__StyledCloseIcon",
  componentId: "sc-h4zmd3-2"
})(["", " margin-left:auto;& i{", "}"], (0, _ty["default"])(_templateObject4 || (_templateObject4 = (0, _taggedTemplateLiteral2["default"])(["\n    ", "\n    pr2 lh-solid f4 flex items-center\n  "])), function (_ref6) {
  var _alert$icons$type2;

  var alert = _ref6.theme.alert,
      type = _ref6.type;
  return (_alert$icons$type2 = alert.icons[type]) === null || _alert$icons$type2 === void 0 ? void 0 : _alert$icons$type2.color;
}), (0, _ty["default"])(_templateObject5 || (_templateObject5 = (0, _taggedTemplateLiteral2["default"])(["flex"]))));

exports.StyledCloseIcon = StyledCloseIcon;